import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isLoggedIn } from "./auth";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={
        (props) =>
          isLoggedIn() ? <Component {...props} /> : <Redirect to="/" /> //&& userResult.role === "USER_ADMIN"
      }
    />
  );
};
